<template>
    <div :class="`${surveyMode ? 'text-area-custom-sublabel-mode' : ''}`">
        <p v-if="surveyMode" class="surveys-common-label pb-0 mb-1" >
            {{`${requiredCharLabel}`}}
            <span v-if="sublabel" class="surveys-common-sublabel"><br> {{sublabel}}</span>
        </p>
        <v-textarea
            :label="surveyMode ? '' : requiredCharLabel"
            filled
            color="success"
            v-model="value" 
            hide-details="auto" 
            outlined 
            dense 
            :rules="rule"
            :error-messages="errorMessages"
            :rows="rows != null ? rows : 5"
            auto-grow
            :readonly="readonly"
        ></v-textarea>
    </div>

</template>
<script>
export default {
    props: ['valueInput', 'rule', 'label', 'errorMessages', 'rows', 'readonly', 'sublabel', 'surveyMode'],
    model: {
        prop: 'value',
        event: 'valueChange'
    },
    computed: {
        value: {
            get: function() {
                return this.valueInput
            },
            set: function(value) {
                this.$emit('valueChange', value+"".trim())
            }
        },
        requiredCharLabel:{
            get: function(){
                if(this.label == "" || this.label == undefined)
                    return "";
                const response = this.label + " *";
                for (let i = 0; i < (this?.rule?.length??[]); i++) {
                    if(this.rule[i]("") != true){
                        return response;
                    }
                }
                return this.label;
            }
        }
    }
}
</script>


<style lang="scss">

    .text-area-custom-sublabel-mode{

    }

    .text-area-custom-sublabel-mode .v-text-field .v-input__control .v-input__slot textarea{
        // //margin-bottom: 8px;
        margin-top: 0px !important;
        padding: 0;
    }
    .text-area-custom-sublabel-mode .v-text-field .v-input__control .v-input__slot textarea{
    //margin-bottom: 8px;
        margin-top: 5px !important;
        padding: 0;
    }


</style>